export const reachGoal = (target:string, params:object, callback: Function) => {
    const { YA_METRIKA_ID } = useRuntimeConfig().public;

    if (!import.meta.client) return;

    if ((window as any)['disableYaCounter42914764']) return;

    if (window.ym) {
        window.ym(YA_METRIKA_ID, 'reachGoal', target, params, callback);
    }
}